var exports = {
  "q7": "Item__LqKoIH",
  "hJ": "Overlay__b3xU57",
  "O3": "LegacyOverlay__wgiMEy",
};

module.exports = exports;
